import { render, staticRenderFns } from "./Sankey.vue?vue&type=template&id=0ccb46f2&"
import script from "./Sankey.vue?vue&type=script&lang=js&"
export * from "./Sankey.vue?vue&type=script&lang=js&"
import style0 from "./Sankey.vue?vue&type=style&index=0&id=0ccb46f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports